import type { FC } from 'react';
import { Box, Grid, } from '@material-ui/core';
import CurvaProduccionTableIngreso from './CurvaProduccionTableIngreso';
import CurvaProduccionChartLineIngreso from './CurvaProduccionChartLineIngreso';
import CurvaProduccionChartBarLineIngreso from './CurvaProduccionChartBarLineIngreso';

const CurvaProduccionIngreso: FC<{ headers: any[], data: any }> = ({ headers, data }) => (
  <>
    <Box p={0}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <CurvaProduccionTableIngreso data={data} headers={headers} />
        </Grid>
        <Grid item xs={12} md={6}>
          <CurvaProduccionChartLineIngreso data={data} headers={headers} title="Real Acum. Vs Fcst Acum." />
        </Grid>
        <Grid item xs={12} md={6}>
          <CurvaProduccionChartBarLineIngreso data={data} headers={headers} title="Ingresos: #Operaciones" />
        </Grid>
      </Grid>
    </Box>
  </>
);

export default CurvaProduccionIngreso;
